import { useEffect, useState } from 'react';
import type { LegacyChoiceResult } from '@core-api/presentation/types/response';
import type { Choice } from '../types';

interface useIdentifiedResultsListStateProps {
  choices: Choice[];
  identifiedResults: LegacyChoiceResult[];
  shouldHideResults: boolean;
}

export const useIdentifiedResultsListState = ({
  choices,
  identifiedResults,
  shouldHideResults,
}: useIdentifiedResultsListStateProps) => {
  const [identitiesListChoiceId, setIdentitiesListChoiceId] = useState<
    Choice['id'] | null
  >(null);

  useEffect(() => {
    if (shouldHideResults) {
      setIdentitiesListChoiceId(null);
    }
  }, [shouldHideResults, setIdentitiesListChoiceId]);

  const identityListChoice = choices.find(
    (c) => c.id === identitiesListChoiceId,
  );
  const identityListChoiceIndex = choices.findIndex(
    (c) => c.id === identitiesListChoiceId,
  );
  const activeChoiceIdentities = identifiedResults?.find(
    (option) => option.legacyChoiceId === identitiesListChoiceId,
  );

  return {
    setIdentitiesListChoiceId,
    identityListChoice,
    identityListChoiceIndex,
    activeChoiceIdentities,
  };
};
